import { useBanner, BannerCloseIcon, useBannerStylesheet } from "../../..";
import { forwardRef } from "react";
import { extendBannerContentStylesheet, extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";

// eslint-disable-next-line react/display-name
const BannerHeader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className
  } = _ref;
  const stylesheet = useBannerStylesheet();
  const {
    a11yIds,
    HeaderContainer,
    hasCloseIcon,
    HeaderTitle
  } = stylesheet.extend(...extendBannerContentStylesheet).extend(...extendCommonContentStylesheet);
  const {
    headerDesign: {
      logo,
      logoRetina,
      logoAlt
    },
    decision: {
      showCloseIcon
    },
    texts: {
      headline
    },
    activeAction,
    individualPrivacyOpen,
    individualTexts,
    i18n: {
      headerTitlePrivacyPolicyHistory
    }
  } = useBanner();

  // Calculate logo
  const useRetina = logoRetina && !logo?.endsWith(".svg") && window.devicePixelRatio > 1;
  const useLogo = useRetina ? logoRetina : logo;

  // Calculate headline
  const useCloseIcon = !!showCloseIcon || !!activeAction;
  const useHeadline = individualPrivacyOpen ? activeAction === "history" ? headerTitlePrivacyPolicyHistory : individualTexts.headline : headline;
  return h(HeaderContainer, {
    ref: ref,
    className: className
  }, h("div", null, !!useLogo && h("img", {
    "aria-hidden": true,
    alt: logoAlt || "",
    src: useLogo
  }), !!useHeadline && h(HeaderTitle, {
    id: a11yIds.headline,
    className: useCloseIcon ? hasCloseIcon : undefined
  }, useHeadline), useCloseIcon && h(BannerCloseIcon, null)));
});
export { BannerHeader };